import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { projectSettingsSoftwareNotificationEmailRoute } from '@jira/router-routes__project-settings-product-routes-software-routes/src/projectSettingsSoftwareNotificationEmailRoute.tsx';
import { ProjectSettingsFeaturesSkeleton } from '@jira/platform__skeletons/src/ui/project-settings/ProjectSettingsFeaturesSkeleton.tsx';
import { softwareProjectLayoutNoOnboarding } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import {
	RedirectForSettings,
	getSettingsNavigationResources,
} from './ui/project-settings/product-routes/common/index.tsx';

export const projectSettingsSoftwareNotificationEmailRouteEntry: Route = createEntry(
	projectSettingsSoftwareNotificationEmailRoute,

	() => ({
		group: 'project-settings-software',
		// eslint-disable-next-line no-restricted-syntax
		component: RedirectForSettings,
		skeleton: ProjectSettingsFeaturesSkeleton,
		layout: softwareProjectLayoutNoOnboarding,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [...getSettingsNavigationResources()],
		forPaint: [LazyAtlassianNavigation],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
